import React from "react";
import { useTranslation } from "react-i18next";

import Link from "@mui/material/Link";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { StyledSwitch } from "../../components/Base";
import Button from "../../components/Button";

const OperationItem = ({ onEdit, onDelete, onStatusChange, operation }) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell>{operation.id}</TableCell>
      <TableCell>{operation.name}</TableCell>
      <TableCell>{operation.positions}</TableCell>
      <TableCell>
        <StyledSwitch
          title={t("operations_page.change_status")}
          checked={operation.status === "active"}
          onChange={() => onStatusChange(operation.id, operation.status === "active" ? "passive" : "active")}
        />
      </TableCell>
      <TableCell>
        <Link style={{ marginRight: "1rem" }} onClick={() => onEdit(operation.id)}>
          <Button title={t("operations_page.edit_action")} icon={<EditIcon />} />
        </Link>
        <Link onClick={() => onDelete(operation.id)}>
          <Button title={t("operations_page.delete_action")} icon={<DeleteForeverIcon color="error" />} />
        </Link>
      </TableCell>
    </TableRow>
  );
};

export default OperationItem;
